import { render, staticRenderFns } from "./InsertDocSupplierDocs.vue?vue&type=template&id=17736e61&"
import script from "./InsertDocSupplierDocs.vue?vue&type=script&lang=js&"
export * from "./InsertDocSupplierDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports